import React from 'react';
import { Stack } from '@mui/material';
import InconsistenciesWrapper, {
    InconsistenciesWrapperProps,
} from 'components/common/concierge-kg-control/InconsistenciesWrapper';
import { useStageGateConfig } from './StageGateContext';
import { useEditPanelBridge } from './EditPanelBridge';
import MoveBlockedBanner from './MoveBlockedBanner';
import FormTabContentDefaultStacks from 'components/common/form/layout/tab/FormTabContentDefaultStacks';
import { ITabProps } from 'components/common/form/layout/tab';

interface IssuesTabProps extends InconsistenciesWrapperProps, ITabProps {}

export default function IssuesTab({ issues, onOpenConcierge, objectType = 'report', ...tabProps }: IssuesTabProps) {
    const gates = useStageGateConfig();
    const bridge = useEditPanelBridge();
    const moveBlock = bridge?.moveBlock ?? null;
    const inconsistenciesExpandToken = bridge?.inconsistenciesExpandToken ?? 0;
    const clarificationsExpandToken = bridge?.clarificationsExpandToken ?? 0;

    if (!issues.context) {
        return null;
    }
    return (
        <FormTabContentDefaultStacks {...tabProps}>
            <></>
            <>
                <Stack spacing={2} sx={{ width: '100%' }}>
                    {moveBlock && <MoveBlockedBanner key={moveBlock.attempt} block={moveBlock} />}
                    <InconsistenciesWrapper
                        issues={issues}
                        onOpenConcierge={onOpenConcierge}
                        objectType={objectType}
                        showInconsistencies={gates.showInconsistencies}
                        keepInconsistenciesCard
                        showClarifications={gates.showClarifications}
                        clarificationsNeedKgManager
                        inconsistenciesExpandToken={
                            inconsistenciesExpandToken > 0 ? inconsistenciesExpandToken : undefined
                        }
                        clarificationsExpandToken={
                            clarificationsExpandToken > 0 ? clarificationsExpandToken : undefined
                        }
                    />
                </Stack>
            </>
        </FormTabContentDefaultStacks>
    );
}
